import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/kombit.png'
import _imports_1 from '@/assets/mitid.png'
import _imports_2 from '@/assets/european.png'


const _hoisted_1 = { class: "text-muted" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Vi fandt ")
const _hoisted_4 = { class: "text-primary" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" profiler ")
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "d-flex align-items-center gap-2" }
const _hoisted_8 = {
  key: 0,
  style: {"width":"25px"},
  src: _imports_0
}
const _hoisted_9 = {
  key: 1,
  style: {"width":"50px"},
  src: _imports_1
}
const _hoisted_10 = {
  key: 2,
  style: {"width":"30px"},
  src: _imports_2
}
const _hoisted_11 = { class: "d-flex" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = {
  class: "d-flex",
  style: {"gap":"10px"}
}
const _hoisted_14 = { class: "text-muted" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = {
  class: "d-flex",
  style: {"gap":"10px"}
}
const _hoisted_17 = { class: "text-muted" }
const _hoisted_18 = {
  class: "text-center",
  style: {"gap":"10px"}
}
const _hoisted_19 = { class: "text-muted" }
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = { class: "ms-auto d-flex gap-2" }
const _hoisted_22 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/_createVNode("small", null, "Denne bruger har ingen tildelte roller", -1)
const _hoisted_25 = { class: "d-flex" }
const _hoisted_26 = { class: "d-flex align-items-center gap-2" }
const _hoisted_27 = {
  key: 0,
  style: {"width":"25px"},
  src: _imports_0
}
const _hoisted_28 = {
  key: 1,
  style: {"width":"50px"},
  src: _imports_1
}
const _hoisted_29 = {
  key: 2,
  style: {"width":"30px"},
  src: _imports_2
}
const _hoisted_30 = { class: "d-flex" }
const _hoisted_31 = { class: "d-flex align-items-center" }
const _hoisted_32 = {
  class: "d-flex",
  style: {"gap":"10px"}
}
const _hoisted_33 = { class: "text-muted" }
const _hoisted_34 = { class: "d-flex align-items-center" }
const _hoisted_35 = {
  class: "d-flex",
  style: {"gap":"10px"}
}
const _hoisted_36 = { class: "text-muted" }
const _hoisted_37 = { class: "text-center" }
const _hoisted_38 = { class: "text-muted" }
const _hoisted_39 = { class: "d-flex align-items-center" }
const _hoisted_40 = {
  class: "d-flex",
  style: {"gap":"10px"}
}
const _hoisted_41 = { class: "text-muted" }
const _hoisted_42 = { class: "d-flex align-items-center" }
const _hoisted_43 = { class: "ms-auto d-flex gap-2" }
const _hoisted_44 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_45 = { key: 1 }
const _hoisted_46 = /*#__PURE__*/_createVNode("small", null, "Denne bruger har ingen tildelte roller", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AssignUserRoleOnBehalfOfModal = _resolveComponent("AssignUserRoleOnBehalfOfModal")!
  const _component_organization_modal = _resolveComponent("organization-modal")!
  const _component_reset_password_modal = _resolveComponent("reset-password-modal")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_error = _resolveComponent("error")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_User = _resolveComponent("User")!
  const _component_page = _resolveComponent("page")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(_component_AssignUserRoleOnBehalfOfModal, {
      ref: "assignUserRoleOnBehalfOfModal",
      organization: _ctx.organization,
      onReloadTables: _ctx.reloadTables
    }, null, 8, ["organization", "onReloadTables"]),
    _createVNode(_component_organization_modal, {
      organization: _ctx.organization,
      ref: "organizationModal"
    }, null, 8, ["organization"]),
    _createVNode(_component_reset_password_modal, { ref: "resetPasswordModal" }, null, 512),
    _createVNode(_component_page, {
      isLoading: _ctx.loading && !_ctx.firstLoad,
      error: _ctx.error
    }, {
      default: _withCtx(() => [
        (_ctx.organization)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_app_header, {
                titleButtonIcon: _ctx.canManageUsersRole ? 'edit' : null,
                searchPlaceholder: "Indtast fornavn, efternavn eller mailadresse...",
                canSearch: true,
                searchEntry: _ctx.searchText,
                "onUpdate:searchEntry": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchText = $event)),
                actionButtonTitle: 
          _ctx.canManageUsers && _ctx.canCreateProfile(_ctx.organization.vat)
            ? 'Opret profil'
            : undefined
        ,
                onOnTitleButton: _cache[2] || (_cache[2] = ($event: any) => (
          _ctx.organization ? _ctx.organizationModal?.show(_ctx.organization) : null
        )),
                title: _ctx.organization?.name,
                onOnActionButton: _cache[3] || (_cache[3] = ($event: any) => (
          _ctx.userSidebar.showUserSidebar({
            userId: 'new',
            organization: _ctx.organization,
          })
        )),
                assignRoleButtonTitle: 
          _ctx.canManageUsersRole && _ctx.isNotUkendtOrganisation(_ctx.organization.vat)
            ? 'Tildel rolle på vegne af'
            : undefined
        ,
                onOnAssignRoleButton: _cache[4] || (_cache[4] = ($event: any) => (_ctx.assignUserRoleOnBehalfOfModal?.show(_ctx.organization))),
                exportUserProfilesToExcelTitle: 
          _ctx.canManageUsersRole ? 'Eksportér brugerprofiler til Excel' : undefined
        ,
                onExportUserProfilesToExcel: _ctx.exportUserProfilesToExcel,
                exportUserProfilesToExcelLoading: _ctx.exportUserProfilesToExcelLoading
              }, {
                titleDetails: _withCtx(() => [
                  _createVNode("small", _hoisted_1, [
                    (_ctx.organization.vat)
                      ? (_openBlock(), _createBlock("span", _hoisted_2, "CVR: " + _toDisplayString(_ctx.organization.vat), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                subtitle: _withCtx(() => [
                  _createVNode("strong", null, [
                    _hoisted_3,
                    _createVNode("span", _hoisted_4, _toDisplayString((_ctx.organization?.users?.total || 0) +
                (_ctx.organization?.oboUsers?.total || 0)), 1),
                    _hoisted_5
                  ])
                ]),
                _: 1
              }, 8, ["titleButtonIcon", "searchEntry", "actionButtonTitle", "title", "assignRoleButtonTitle", "exportUserProfilesToExcelTitle", "onExportUserProfilesToExcel", "exportUserProfilesToExcelLoading"]),
              _createVNode(_component_TabView, {
                activeIndex: _ctx.activeTab,
                "onUpdate:activeIndex": _cache[7] || (_cache[7] = ($event: any) => (_ctx.activeTab = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TabPanel, {
                    header: `Profiler fra egen organisation (${_ctx.organization?.users?.total})`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DataTable, {
                        selectionMode: "single",
                        sortField: "fullname",
                        sortOrder: 1,
                        responsiveLayout: "scroll",
                        globalFilterFields: ['fullname', 'email', 'mitID'],
                        dataKey: "userId",
                        value: 
              (_ctx.organization?.users?.items ?? []).map((user) => ({
                ...user,
                fullname: user ? `${user?.firstname} ${user?.lastname}` : '',
              }))
            ,
                        class: "bg-white rounded",
                        onRowClick: _cache[5] || (_cache[5] = ($event: any) => (
              _ctx.canManageUsersRole
                ? _ctx.userSidebar.showUserSidebar($event.data)
                : null
            ))
                      }, {
                        empty: _withCtx(() => [
                          _createVNode(_component_error, {
                            error: {
                  title: _ctx.searchText ? 'Ingen resultater' : 'Ingen brugere',
                  message: _ctx.searchText
                    ? 'Din søgning gav ingen resultater'
                    : 'Der er ikke nogle brugere oprettet under denne organisation endnu',
                }
                          }, null, 8, ["error"])
                        ]),
                        expansion: _withCtx((slotProps) => [
                          (slotProps.data.roles.length > 0)
                            ? (_openBlock(), _createBlock("div", _hoisted_22, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(slotProps.data.roles, (role) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "me-2 my-1 bg-secondary px-2 text-white",
                                    key: role
                                  }, [
                                    _createVNode("small", null, [
                                      _createVNode("span", null, _toDisplayString(role.applicationName) + " - ", 1),
                                      _createTextVNode(_toDisplayString(role.roleName), 1)
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createBlock("div", _hoisted_23, [
                                _hoisted_24
                              ]))
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            field: "adminIcon",
                            style: {"width":"50px","padding-right":"unset"}
                          }, {
                            body: _withCtx((slotProps) => [
                              _withDirectives(_createVNode("div", _hoisted_6, [
                                (slotProps.data.administrator)
                                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 0,
                                      icon: ['fas', 'crown']
                                    }))
                                  : _createCommentVNode("", true)
                              ], 512), [
                                [
                                  _directive_tooltip,
                                  'Lokal administrator',
                                  void 0,
                                  { top: true }
                                ]
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "externalIcon",
                            style: {"width":"120px","padding-right":"16px","padding-left":"16px"}
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode("div", _hoisted_7, [
                                (slotProps.data.kombitID)
                                  ? _withDirectives((_openBlock(), _createBlock("img", _hoisted_8, null, 512)), [
                                      [
                                        _directive_tooltip,
                                        'Kombit',
                                        void 0,
                                        { top: true }
                                      ]
                                    ])
                                  : _createCommentVNode("", true),
                                (slotProps.data.mitID)
                                  ? _withDirectives((_openBlock(), _createBlock("img", _hoisted_9, null, 512)), [
                                      [
                                        _directive_tooltip,
                                        'MitID',
                                        void 0,
                                        { top: true }
                                      ]
                                    ])
                                  : _createCommentVNode("", true),
                                (slotProps.data.eID)
                                  ? _withDirectives((_openBlock(), _createBlock("img", _hoisted_10, null, 512)), [
                                      [
                                        _directive_tooltip,
                                        'eID',
                                        void 0,
                                        { top: true }
                                      ]
                                    ])
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "fullname",
                            style: {"padding-left":"unset"}
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode("div", _hoisted_11, [
                                _withDirectives(_createVNode("strong", null, [
                                  _createTextVNode(_toDisplayString(slotProps.data.fullname), 1)
                                ], 512), [
                                  [
                                    _directive_tooltip,
                                    'Navn',
                                    void 0,
                                    { top: true }
                                  ]
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, { field: "email" }, {
                            body: _withCtx((slotProps) => [
                              _createVNode("div", _hoisted_12, [
                                _createVNode("div", _hoisted_13, [
                                  _withDirectives(_createVNode("span", _hoisted_14, [
                                    _createTextVNode(_toDisplayString(slotProps.data.email), 1)
                                  ], 512), [
                                    [
                                      _directive_tooltip,
                                      'E-mail',
                                      void 0,
                                      { top: true }
                                    ]
                                  ])
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "creationDate",
                            header: "Oprettet"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode("div", _hoisted_15, [
                                _createVNode("div", _hoisted_16, [
                                  _withDirectives(_createVNode("span", _hoisted_17, [
                                    _createTextVNode(_toDisplayString(_ctx.displayUserCreationDate(
                        slotProps.data.creationDate,
                        slotProps
                      )), 1)
                                  ], 512), [
                                    [
                                      _directive_tooltip,
                                      'Oprettet',
                                      void 0,
                                      { top: true }
                                    ]
                                  ])
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "totalDays",
                            header: "Seneste login"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode("div", _hoisted_18, [
                                _withDirectives(_createVNode("span", _hoisted_19, [
                                  _createTextVNode(_toDisplayString(_ctx.totalDaysSinceLastLogin(slotProps.data.lastLogin)), 1)
                                ], 512), [
                                  [
                                    _directive_tooltip,
                                    'Seneste login',
                                    void 0,
                                    { top: true }
                                  ]
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "resetPassword",
                            header: "Nulstil adgangskode"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createVNode("div", _hoisted_20, [
                                _createVNode("div", _hoisted_21, [
                                  (
                        _ctx.canResetPassword(_ctx.organization.vat) &&
                        !slotProps.data.mitID &&
                        !slotProps.data.kombitID &&
                        !slotProps.data.eID
                      )
                                    ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                        key: 0,
                                        class: "secondary rounded-circle inverted p-2",
                                        type: "button",
                                        onClick: _withModifiers(($event: any) => (_ctx.resetPasswordModal?.show(slotProps.data)), ["stop"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'key'] })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])), [
                                        [
                                          _directive_tooltip,
                                          'Nulstil adgangskode',
                                          void 0,
                                          { top: true }
                                        ]
                                      ])
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"]),
                      _createVNode(_component_Pagination, {
                        rows: _ctx.pageParams.pageSize,
                        totalRecords: _ctx.organization?.users?.total,
                        page: _ctx.pageParams.currentPage! - 1,
                        onPageChange: _ctx.onPageChange
                      }, null, 8, ["rows", "totalRecords", "page", "onPageChange"])
                    ]),
                    _: 1
                  }, 8, ["header"]),
                  (_ctx.isNotUkendtOrganisation(_ctx.organization.vat))
                    ? (_openBlock(), _createBlock(_component_TabPanel, {
                        key: 0,
                        header: `Profiler på vegne af (${_ctx.organization?.oboUsers?.total})`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DataTable, {
                            selectionMode: "single",
                            sortField: "fullname",
                            sortOrder: 1,
                            responsiveLayout: "scroll",
                            globalFilterFields: ['fullname', 'email', 'mitID'],
                            dataKey: "userId",
                            value: 
              (_ctx.organization?.oboUsers?.items ?? []).map((user) => ({
                ...user,
                fullname: user ? `${user?.firstname} ${user?.lastname}` : '',
              }))
            ,
                            class: "bg-white rounded",
                            onRowClick: _cache[6] || (_cache[6] = ($event: any) => (
              _ctx.canManageUsersRole
                ? _ctx.userSidebar.showUserSidebar($event.data)
                : null
            ))
                          }, {
                            empty: _withCtx(() => [
                              _createVNode(_component_error, {
                                error: {
                  title: _ctx.searchText ? 'Ingen resultater' : 'Ingen brugere',
                  message: _ctx.searchText
                    ? 'Din søgning gav ingen resultater'
                    : 'Der er ikke nogle brugere oprettet under denne organisation endnu',
                }
                              }, null, 8, ["error"])
                            ]),
                            expansion: _withCtx((slotProps) => [
                              (slotProps.data.roles.length > 0)
                                ? (_openBlock(), _createBlock("div", _hoisted_44, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(slotProps.data.roles.filter(
                    (r) => r.organizationId === _ctx.organization?.organizationId
                  ), (role) => {
                                      return (_openBlock(), _createBlock("div", {
                                        class: "me-2 my-1 bg-secondary px-2 text-white",
                                        key: role
                                      }, [
                                        _createVNode("small", null, [
                                          _createVNode("span", null, _toDisplayString(role.applicationName) + " - ", 1),
                                          _createTextVNode(_toDisplayString(role.roleName), 1)
                                        ])
                                      ]))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createBlock("div", _hoisted_45, [
                                    _hoisted_46
                                  ]))
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_Column, {
                                field: "adminIcon",
                                style: {"width":"50px","padding-right":"unset"}
                              }, {
                                body: _withCtx((slotProps) => [
                                  _withDirectives(_createVNode("div", _hoisted_25, [
                                    (slotProps.data.administrator)
                                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                          key: 0,
                                          icon: ['fas', 'crown']
                                        }))
                                      : _createCommentVNode("", true)
                                  ], 512), [
                                    [
                                      _directive_tooltip,
                                      'Lokal administrator',
                                      void 0,
                                      { top: true }
                                    ]
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                field: "externalIcon",
                                style: {"width":"120px","padding-right":"16px","padding-left":"16px"}
                              }, {
                                body: _withCtx((slotProps) => [
                                  _createVNode("div", _hoisted_26, [
                                    (slotProps.data.kombitID)
                                      ? _withDirectives((_openBlock(), _createBlock("img", _hoisted_27, null, 512)), [
                                          [
                                            _directive_tooltip,
                                            'Kombit',
                                            void 0,
                                            { top: true }
                                          ]
                                        ])
                                      : _createCommentVNode("", true),
                                    (slotProps.data.mitID)
                                      ? _withDirectives((_openBlock(), _createBlock("img", _hoisted_28, null, 512)), [
                                          [
                                            _directive_tooltip,
                                            'MitID',
                                            void 0,
                                            { top: true }
                                          ]
                                        ])
                                      : _createCommentVNode("", true),
                                    (slotProps.data.eID)
                                      ? _withDirectives((_openBlock(), _createBlock("img", _hoisted_29, null, 512)), [
                                          [
                                            _directive_tooltip,
                                            'eID',
                                            void 0,
                                            { top: true }
                                          ]
                                        ])
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                field: "fullname",
                                style: {"padding-left":"unset"}
                              }, {
                                body: _withCtx((slotProps) => [
                                  _createVNode("div", _hoisted_30, [
                                    _withDirectives(_createVNode("strong", null, [
                                      _createTextVNode(_toDisplayString(slotProps.data.fullname), 1)
                                    ], 512), [
                                      [
                                        _directive_tooltip,
                                        'Navn',
                                        void 0,
                                        { top: true }
                                      ]
                                    ])
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, { field: "email" }, {
                                body: _withCtx((slotProps) => [
                                  _createVNode("div", _hoisted_31, [
                                    _createVNode("div", _hoisted_32, [
                                      _withDirectives(_createVNode("span", _hoisted_33, [
                                        _createTextVNode(_toDisplayString(slotProps.data.email), 1)
                                      ], 512), [
                                        [
                                          _directive_tooltip,
                                          'E-mail',
                                          void 0,
                                          { top: true }
                                        ]
                                      ])
                                    ])
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                field: "creationDate",
                                header: "Oprettet",
                                style: {"padding":"unset"}
                              }, {
                                body: _withCtx((slotProps) => [
                                  _createVNode("div", _hoisted_34, [
                                    _createVNode("div", _hoisted_35, [
                                      _withDirectives(_createVNode("span", _hoisted_36, [
                                        _createTextVNode(_toDisplayString(_ctx.displayUserCreationDate(
                        slotProps.data.creationDate,
                        slotProps
                      )), 1)
                                      ], 512), [
                                        [
                                          _directive_tooltip,
                                          'Oprettet',
                                          void 0,
                                          { top: true }
                                        ]
                                      ])
                                    ])
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                field: "totalDays",
                                header: "Seneste login",
                                style: {"width":"150px"}
                              }, {
                                body: _withCtx((slotProps) => [
                                  _createVNode("div", _hoisted_37, [
                                    _withDirectives(_createVNode("span", _hoisted_38, [
                                      _createTextVNode(_toDisplayString(_ctx.totalDaysSinceLastLogin(slotProps.data.lastLogin)), 1)
                                    ], 512), [
                                      [
                                        _directive_tooltip,
                                        'Seneste login',
                                        void 0,
                                        { top: true }
                                      ]
                                    ])
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, { field: "organization" }, {
                                body: _withCtx((slotProps) => [
                                  _createVNode("div", _hoisted_39, [
                                    _createVNode("div", _hoisted_40, [
                                      _withDirectives(_createVNode("span", _hoisted_41, [
                                        _createTextVNode(_toDisplayString(slotProps.data.organizationName || "Ingen organisation"), 1)
                                      ], 512), [
                                        [
                                          _directive_tooltip,
                                          'Organisation',
                                          void 0,
                                          { top: true }
                                        ]
                                      ])
                                    ])
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                field: "resetPassword",
                                header: "Nulstil adgangskode"
                              }, {
                                body: _withCtx((slotProps) => [
                                  _createVNode("div", _hoisted_42, [
                                    _createVNode("div", _hoisted_43, [
                                      (
                        _ctx.canManageUsers &&
                        !slotProps.data.mitID &&
                        !slotProps.data.kombitID &&
                        !slotProps.data.eID
                      )
                                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                            key: 0,
                                            class: "secondary rounded-circle inverted p-2",
                                            type: "button",
                                            onClick: _withModifiers(($event: any) => (_ctx.resetPasswordModal?.show(slotProps.data)), ["stop"])
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'key'] })
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])), [
                                            [
                                              _directive_tooltip,
                                              'Nulstil adgangskode',
                                              void 0,
                                              { top: true }
                                            ]
                                          ])
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"]),
                          _createVNode(_component_Pagination, {
                            rows: _ctx.pageParams.pageSize,
                            totalRecords: _ctx.organization?.oboUsers?.total,
                            page: _ctx.pageParams.currentPage! - 1,
                            onPageChange: _ctx.onPageChange
                          }, null, 8, ["rows", "totalRecords", "page", "onPageChange"])
                        ]),
                        _: 1
                      }, 8, ["header"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["activeIndex"]),
              (_ctx.userSidebar.selectedUser.value && !_ctx.userSidebar.isHiding.value)
                ? (_openBlock(), _createBlock(_component_User, {
                    key: `user-${_ctx.userSidebar.selectedUser.value?.userId || 'new'}`,
                    id: _ctx.userSidebar.selectedUser?.value?.userId ?? '',
                    "organization-id": 
          _ctx.userSidebar.selectedUser?.value?.organization?.organizationId ?? ''
        ,
                    organization: _ctx.organization,
                    onHide: _ctx.userSidebar.hideUserSidebar,
                    onUserCreated: _ctx.reloadTables,
                    onUserUpdated: _ctx.reloadTables,
                    onUserDeleted: _ctx.reloadTables,
                    onReloadTables: _ctx.reloadTables
                  }, null, 8, ["id", "organization-id", "organization", "onHide", "onUserCreated", "onUserUpdated", "onUserDeleted", "onReloadTables"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["isLoading", "error"])
  ], 64))
}